import { useApi } from "../useApi";
import {
  GuestManagementUrl,
  GuestManagementClassificationUrl,
} from "../../utils/constants";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  IGuestManagement,
  IGuestManagementClassification,
  IUpdateGuests,
} from "./types";
import i18n from "../../i18n";

const useGuestManagement = () => {
  const { apiPrivate } = useApi();

  const Guests = async (params: {
    pageSize: string;
    pageNumber: string;
    searchQuery?: string;
    selectedNames?: string[];
    category?: string;
  }) => {
    // Build query params to match the curl example
    const lang = i18n.language || 'ar';
    const queryParams: any = {
      pageSize: params.pageSize,
      pageNumber: params.pageNumber,
      lang,
    };

    if (params?.searchQuery) {
      queryParams.searchQuery = params?.searchQuery;
    }
    if (params?.selectedNames && params?.selectedNames?.length > 0) {
      queryParams.selectedNames = params?.selectedNames;
    }
    if (params?.category) {
      queryParams.category = params.category;
    }

    const response: { data: IGuestManagement } = await apiPrivate.get(
      GuestManagementUrl,
      {
        params: queryParams,
      }
    );
    return response;
  };

  const GuestManagementClassification = async () => {
    const lang = i18n.language || 'ar';
    const response: { data: IGuestManagementClassification } =
      await apiPrivate.get(GuestManagementClassificationUrl, {
        params: { lang }
      });
    return response;
  };

  const GuestsQuery = (data: {
    pageSize: string;
    pageNumber: string;
    searchQuery?: string;
    selectedNames?: string[];
    category?: string;
  }) =>
    useQuery({
      queryKey: [GuestManagementUrl, data],
      queryFn: () => Guests(data),
    });

  const GuestManagementClassificationQuery = () =>
    useQuery({
      queryKey: [GuestManagementClassificationUrl],
      queryFn: GuestManagementClassification,
    });

  const updateGuests = async ({ ...rest }: IUpdateGuests) => {
    let response;
    response = await apiPrivate.put(`${GuestManagementUrl}`, { ...rest });
    return response;
  };

  const updateGuestsMutate = () =>
    useMutation({
      mutationFn: ({ ...rest }: IUpdateGuests) => updateGuests({ ...rest }),
    });

  return {
    GuestsQuery,
    GuestManagementClassificationQuery,
    updateGuestsMutate,
  };
};
export { useGuestManagement };
